import { Currency, Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { ShoppingCartItem, ShoppingCartSupplier } from '../shopping-cart';
import { ShoppingCartSupplierDto } from '../dto/shopping-cart-dto';
import { mapBonusCondition } from './bonus-condition-mapper';
import { mapShoppingCartItem } from './shopping-cart-item-mapper';

export const mapShoppingCartSupplier = (
    supplier: ShoppingCartSupplierDto,
    locales: Locale[],
    currency: Currency
): ShoppingCartSupplier | null => {
    const items = supplier.items?.map(item => mapShoppingCartItem(item, locales, currency)) ?? [];
    if (items.some(item => item === null)) {
        return null;
    }

    return {
        id: supplier.id,
        name: supplier.name,
        image: supplier.image,
        conditions: supplier.conditions?.map(condition => mapBonusCondition(condition)) ?? [],
        termsOfDelivery: supplier.termsOfDelivery,
        paymentTerm: getLocalizedString(locales, supplier.paymentTerm?.text),
        isChargingSupplier: supplier.isChargingSupplier,
        deliveryCosts: supplier.deliveryCosts ?? 0,
        surcharges: supplier.surcharges ?? 0,
        netTotal: supplier.items?.reduce((result, item) => result + item.quantity * item.netPrice, 0) ?? 0,
        items: items as ShoppingCartItem[],
        requireFunctionalAssets: supplier.requireFunctionalAssets,
        functionalAsset: supplier.functionalAsset,
    };
};
